import React, { useState, useCallback, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon, Button, Switch, message, Dropdown, Menu, Spin } from 'antd';
import {
  Container,
  Title
} from '../../artboard/VariablesList/styles';
import { upgradeModalMessages, TEMPLATE_VARIABLES_SIDEBAR } from '../../artboard/VariablesList/translationValues';
import { COMPLEX_VARIABLES_SIDEBAR } from '../ComplexDocumentDesign/complexVariables/translationValues';
import {
  TitleContainer,
  RowSection,
  ListContainer,
} from '../ComplexDocumentDesign/complexVariables/styles';
import { DownloadButton } from '../ComplexDocumentDesign/styles';
import { useDocumentContext, COMPLEX_DOCUMENT_CONTEXT_KEYS } from '../../context/complexDocumentContext';
import { useEmailContext } from '../../context/complexEmailContext';
import { getTodaysDateWithFormat, jsonToFile, xmlToFile } from '../../utils/javascript';
import { sendTestEmailAPI } from '../../utils/services/complexEmailAPI';
import { releaseEmailDesignbroadcast, showDesignbroadcast, getEmailDisplayStatus, getComplexEmail } from '../../utils/services/complexEmailAPI';
import { dynamicTableHasMoreThanTwoLevels, generatePDFPayload, processCachedDataSet } from '../ComplexDocumentDesign/complexDocumentHelper';
import ComplexEmailPreview from './ComplexEmailPreview';
import { VARIABLE_OBJECT_TYPES, VARIABLE_TYPE, ALL_VARIABLE_OBJECT_TYPES } from '../../utils/constants/appConstants';
import { useArtboardContext, CONTEXT_KEYS, TEMPLATE_TYPE } from '../../context/complexArtboardContext';
import { useSessionContext } from '../../context/sessionContext';
import { useDefaultStyleContext } from '../../context/complexDefaultStyleContext';
import { ENTERPRISE_ENV, checkSessionUserAccess } from '../../utils/helper';
import VariableForm from '../ComplexDocumentDesign/complexVariables/VariableForm';
import SendTestEmail from './SendTestEmail';
import { SEND_EMAIL_MODAL } from '../../components/Modals/translationValues';
import { fetchUserDetails } from '../../utils/services/authAPI';
import { TRANSACTIONS } from '../TemplateSection/translationValues';
import { generateSampleExcel, getPayloadFromFile, getXMLFromJSON } from '../../utils/transactionHelpers';
import SelectOrganization from '../../components/SelectionOrganization';

import {
  sendEmailsFromDraft,
} from '../../utils/services/complexEmailAPI';
import { getIndexedDBData } from '../../utils/indexedDBUtil';

const dummyCallback = () => { };

const constructChartVariable = variables => {
  const source = {};
  const header = [];
  variables.forEach(item => {
    header.push(item.placeHolderText);
    Object.keys(item).forEach(key => {
      if (key === 'placeHolderText') {
        source[item.placeHolderText] = item.exampleValue;
      }
    });
  });
  return { header, source: [source], isObject: true };
};

const NAMESPACES = ['TEMPLATE_VARIABLES_SIDEBAR', 'COMPLEX_VARIABLES_SIDEBAR', 'SEND_EMAIL_MODAL', 'EMAIL_TRANSACTIONS'];

const ComplexEmailVariableList = props => {
  const { setIsHtmlExpanded, isHtmlExpanded, globalVariables, documentVariables, businessLogics, attachments, fromAddressId, subject } = props;
  const { t } = useTranslation(NAMESPACES);

  const [showModal, toggleShowModal] = useState(false);
  const [examplValuesData, setExamplValuesData] = useState({});
  const documentStyleContextRef = useRef(null);

  const getDefaultStyleSelector = useCallback(store => {
    documentStyleContextRef.current = store;
    return null;
  }, []);
  useDefaultStyleContext(getDefaultStyleSelector);
  const fileRef = useRef(null);

  const contextSelector = useCallback(store => store, []);
  const [documentContext] = useDocumentContext(contextSelector);

  const [, emailMethods] = useEmailContext(dummyCallback, []);

  const getCurrentDesign = useCallback(store => store[CONTEXT_KEYS.CURRENT_DESIGN], []);
  const [CurrentDesign, updateArtboard] = useArtboardContext(getCurrentDesign);

  const loaderSelector = useCallback(store => store[CONTEXT_KEYS.GENERATING_PDF], []);
  const [sendingEmail] = useArtboardContext(loaderSelector, 'ComplexEmailVariableList');

  const [toggleButton, setToggleBUtton] = useState(false);
  const [designReleaseLoading, setDesignReleaseLoading] = useState(false);
  const { templateId } = useParams();

  const sessionSelector = useCallback(store => store.userData, []);
  const [userDetails] = useSessionContext(sessionSelector);

  const blocksNotFit = document.getElementsByClassName('block-not-fit');
  const disablePreviewDownload = blocksNotFit.length > 0;

  const [showOrganizationList, setShowOrganizationList] = useState(false);
  const [organizationId, setOrganizationId] = useState('DEFAULT');
  const [errorMessages, setErrorMessages] = useState({});


  useEffect(() => {
    if (checkSessionUserAccess(userDetails, 'master')) {
      (async () => {
        const displayStatus = await getEmailDisplayStatus(templateId);

        if (displayStatus?.statusCode === 3008) {
          setToggleBUtton(displayStatus.data.visible);
          setOrganizationId(displayStatus.data.organizationId);
        }
      })();
    }
  }, [])

  useEffect(() => {
    if (documentVariables?.length > 0) {
    const getSampleData = (variables, parent = undefined) => {
      let sampleData = {};
      let newBlockName = `block1`;
      variables.forEach((element, index) => {
        if (element.type === 'ListString') {
          sampleData = {
            ...sampleData,
            [element.placeHolderText]: {
              key: element.placeHolderText,
              value: [element.exampleValue],
            },
          };
        } else if (element.type === VARIABLE_TYPE.CHART_OBJECT) { // TODO : No handling of form object?
          const objArray = [];
          objArray.push({
            key: element.name,
            subKey: newBlockName,
            name: element.placeHolderText,
            type: element.type,
            isObject: true,
            value: constructChartVariable(element.variables),
            parent
          });
          sampleData = {
            ...sampleData,
            [element.placeHolderText]: {
              value: [{ key: newBlockName, value: objArray }],
              type: element.type,
              key: element.name,
            },
          };
        } else if (VARIABLE_OBJECT_TYPES.includes(element.type) || element.type === VARIABLE_TYPE.TABLE_OBJECT) {
          let objArray = [];
          element.variables.forEach(eachVar => {
            objArray.push({
              key: element.name,
              subKey: newBlockName,
              name: eachVar.placeHolderText,
              type: eachVar.type,
              isObject: true,
              parent,
              value:
                eachVar.type === 'Date'
                  ? getTodaysDateWithFormat()
                  : eachVar.type === 'ListString'
                    ? [eachVar.exampleValue]
                    : eachVar.type === VARIABLE_TYPE.CHART_OBJECT
                      ? constructChartVariable(eachVar.variables)
                      : (eachVar.type === 'object' || eachVar.type === VARIABLE_TYPE.TABLE_OBJECT)
                      ? getSampleData([eachVar], `${parent ? `${parent}.` : ''}${newBlockName}`)[eachVar.placeHolderText]
                      : (eachVar.exampleValue || ''),
              isArray: eachVar.isArray || false
            });
          });
          sampleData = {
            ...sampleData,
            [element.placeHolderText]: {
              value: [{ key: newBlockName, value: objArray }],
              type: element.type,
              key: element.name,
            },
          };
        } else {
          sampleData = {
            ...sampleData,
            [element.placeHolderText]:
              element.type === 'Date'
                ? { key: element.placeHolderText, value: getTodaysDateWithFormat() }
                : { key: element.placeHolderText, value: element.exampleValue },
          };
        }
      });
      return sampleData;
    }
      let designSampleData = getSampleData(documentVariables);
      const datasetCache = JSON.parse(sessionStorage.getItem('datasetCache'));
      if (datasetCache) {
        const mergedSampleData = processCachedDataSet(designSampleData, datasetCache);
        setExamplValuesData(mergedSampleData);
      } else {
        setExamplValuesData(designSampleData);
      }
    }
  }, [documentVariables]);

  useEffect(() => {
    sessionStorage.setItem('datasetCache', JSON.stringify(examplValuesData));
  }, [examplValuesData]);

  const setIsSendingEmail = useCallback((value) => {
    updateArtboard({
      [CONTEXT_KEYS.GENERATING_PDF]: value
    })
  }, []);

  const sendTestEmail = useCallback(async (toAddress, attachmentPassword, downloadPayload = false, e = undefined, format = 'json') => {
    if (e) {
      e.domEvent.stopPropagation();
    }
    if (!downloadPayload) {
      setIsSendingEmail(true);
    }
    let dataSet = { };
    const generateDataSet = (variable, parentDataSet = {}, sampleData = {}) => {
      if (variable.type === VARIABLE_TYPE.OBJECT || variable.type === VARIABLE_TYPE.TABLE_OBJECT) {
        let isArray = variable.name.split('.').length > 1 ? (variable.isArray || false) : true;
        let listArray = [];
        let d = sampleData?.value?.forEach(eachBlock => {
          let blockSamples = {};
          eachBlock.value.forEach(block => {
            if (block.type === VARIABLE_TYPE.CHART_OBJECT) {
              blockSamples[block.name] = block.value.source;
            } else if (block.type === VARIABLE_TYPE.TABLE_OBJECT) {
              blockSamples = generateDataSet(variable.variables.find(v => v.placeHolderText === block.name), blockSamples, block.value);
            } else {
              blockSamples[block.name] = block.value;
            }
          });
          listArray.push(blockSamples);
        });
        parentDataSet = {
          ...parentDataSet,
          [variable.placeHolderText]: isArray ? listArray : listArray[0],
        };
      } else if (variable.type === VARIABLE_TYPE.CHART_OBJECT) {
        const listArray = [];
        sampleData &&
          sampleData.value &&
         sampleData.value.forEach(eachBlock => {
            let blockSamples = {};
            eachBlock.value.forEach(block => {
              blockSamples[block.name] = block.value.source;
            });
            listArray.push(blockSamples);
          });
        parentDataSet = {
          ...parentDataSet,
          ...listArray[0],
        };
      } else {
        parentDataSet = {
          ...parentDataSet,
          [variable.placeHolderText]: sampleData?.value || '',
        };
      }
      return parentDataSet;
    }
    dataSet = {
      ...dataSet,
      uniq_id:'',
      uniq_name:''
    };
    documentVariables.forEach(variable => {
      const key = ALL_VARIABLE_OBJECT_TYPES.includes(variable.type) ? variable.name : variable.placeHolderText;
      dataSet = generateDataSet(variable, dataSet, examplValuesData[key]);
    });

    if(downloadPayload) {
      const sampleJSON = [{
         ...dataSet,
         toEmailAddress: 'sample@example.com',
         attachmentPassword: 'password'
      }];
      if (format === 'json') {
        jsonToFile(sampleJSON, `${documentContext['documentName']}-sample-request`);
      } else if (format === 'xml') {
        const xmlString = getXMLFromJSON({ request: sampleJSON });
        xmlToFile(xmlString, `${documentContext['documentName']}-sample-request`);
      }
      return;
    }
    let extraBlocks = [];
    if (CurrentDesign === 'document') {
      extraBlocks = [
        subject,
        ...attachments
          .filter(attachmentObj => attachmentObj.contentType === 'document')
          .map(attachmentObj => emailMethods.get()[attachmentObj.attachmentId])
      ];
      console.log({ extraBlocks });
    }
    const payload = generatePDFPayload(globalVariables, documentContext, businessLogics, documentStyleContextRef.current, 'flow', undefined, false, false, extraBlocks);
    payload.dataSet = dataSet;
    payload.templateId = payload.documentDTO.documentId;
    payload.documentDTO.flows[0].style.height = 1123; // TODO : check hardcoded value is needed?
    payload.documentDTO.id = payload.documentDTO.documentId;
    payload.documentDTO.fromAddressId = fromAddressId;
    payload.documentDTO.subject = subject;
    payload.documentDTO.attachments = attachments.map(attachmentObj => emailMethods.get()[attachmentObj.attachmentId]);

    delete payload.documentDTO.documentId;
    delete payload.documentDTO.style;
    payload.to = toAddress;
    payload.attachmentPassword = attachmentPassword;
    console.log("payload :: ", payload);
    const response = await sendTestEmailAPI(payload);
    if (response?.statusCode === 1002) { // TODO : Handle the response better
      message.success(t(
        `SEND_EMAIL_MODAL:${SEND_EMAIL_MODAL.SEND_EMAIL_SUCCESS.key}`,
        SEND_EMAIL_MODAL.SEND_EMAIL_SUCCESS.value
      ));
    } else {
      message.error(t(
        `SEND_EMAIL_MODAL:${SEND_EMAIL_MODAL.SEND_EMAIL_FAILURE.key}`,
        SEND_EMAIL_MODAL.SEND_EMAIL_FAILURE.value
      ));
    }
    setIsSendingEmail(false);
    toggleShowModal(false);
  }, [globalVariables, documentVariables, examplValuesData, fromAddressId, subject, attachments, CurrentDesign]);


  const batchExcelSample = useCallback((e) => {
    e.domEvent.stopPropagation();
    const {hasMoreThanTwoLevels} = dynamicTableHasMoreThanTwoLevels(documentVariables);
    if(hasMoreThanTwoLevels){
      message.warning(t(TRANSACTIONS.WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD.key,TRANSACTIONS.WARNING_MESSAGE_SAMPLE_EXCEL_DOWNLOAD.value));
      return;
    }
    const payload = {
      variableContract: documentVariables.map(variable => ({
        type: variable.type,
        id: variable.id,
        name: variable.id ? variable.placeHolderText : variable.name,
        content: variable.variables?.map(childVariable => ({
          type: childVariable.type,
          id: childVariable.id,
          name: childVariable.id ? childVariable.placeHolderText : childVariable.name,
          isArray: childVariable?.isArray,
          content: childVariable.variables?.map(innerChildVariable => ({
            type: innerChildVariable.type,
            id: innerChildVariable.id,
            name: innerChildVariable.id ? innerChildVariable.placeHolderText : innerChildVariable.name
          }))
        }))
      })),
      name: documentContext[COMPLEX_DOCUMENT_CONTEXT_KEYS.DOCUMENT_NAME],
      passwordProtected: attachments?.reduce((acc, t) => acc || t['passwordProtected'], false)
    };
    console.log({ payload });
    generateSampleExcel(payload, true);
  }, [documentVariables, documentContext, attachments]);

  const handleShowDesign = async (toggleButton) => {
    const payLoad = {
      "emailTemplateId": templateId,
      "isVisible": !toggleButton
    }

    const response = await showDesignbroadcast(payLoad);

    if (response.statusCode === 3003) {
      setToggleBUtton(!toggleButton)
    }
  };

  const handleReleaseDesign = async (data) => {
    setDesignReleaseLoading(true);
    setOrganizationId(data?.organizationId ? data?.organizationId : 'All');
    setShowOrganizationList(false);
    const downloadPayload = generatePDFPayload(globalVariables, documentContext, businessLogics, documentStyleContextRef.current, "flow");
    const { documentDTO } = downloadPayload;
    const complexDocument = await getIndexedDBData('complexDocument');
    const documentLIst = await getComplexEmail(templateId);
    if (documentLIst?.statusCode === 707) {
      documentDTO.language = documentLIst?.data?.language;
    }
    documentDTO.id = documentDTO.documentId;
    delete documentDTO.documentId;
    documentDTO.categoryId = complexDocument.categoryId;
    documentDTO.resourceGroup = complexDocument.resourceGroup;
    documentDTO.groupId = complexDocument.groupId;

    let organizationId = {}
    if (data === "All" || data === undefined) {
      organizationId = {};
    } else {
      organizationId = { organizationId: data.organizationId };
    };

    const response = await releaseEmailDesignbroadcast(documentDTO, organizationId);

    if (response?.statusCode === 3001) {
      message.success(t(
        TEMPLATE_VARIABLES_SIDEBAR.DESIGN_RELEASED_SUCCESSFULLY_MESSAGE.key,
        TEMPLATE_VARIABLES_SIDEBAR.DESIGN_RELEASED_SUCCESSFULLY_MESSAGE.value,
      ))
    }
    setDesignReleaseLoading(false);

    handleShowDesign(false);    
  }

  const onImportFile = useCallback((e) => {
    const file = e.target.files[0];

    console.log({ file });

    const reader = new FileReader();
    reader.onload = async event => {
      const binaryString = event.target.result;

    let extraBlocks = [];
    if (CurrentDesign === 'document') {
      extraBlocks = [
        subject,
        ...attachments
          .filter(attachmentObj => attachmentObj.contentType === 'document')
          .map(attachmentObj => emailMethods.get()[attachmentObj.attachmentId])
      ];
      console.log({ extraBlocks });
    }
    const payload = generatePDFPayload(globalVariables, documentContext, businessLogics, documentStyleContextRef.current, 'flow', undefined, false, false, extraBlocks);
    payload.documentDTO.flows[0].style.height = 1123; // TODO : check hardcoded value is needed?
    payload.documentDTO.id = payload.documentDTO.documentId;
    payload.documentDTO.fromAddressId = fromAddressId;
    payload.documentDTO.subject = subject;
    payload.documentDTO.attachments = attachments.map(attachmentObj => emailMethods.get()[attachmentObj.attachmentId]);
    payload.documentDTO.passwordProtected = attachments?.reduce((acc, t) => acc || t['passwordProtected'], false);
    payload.documentDTO.variableContract = payload.documentDTO.variableContract.map(variable => {
      return Object.assign({}, variable, {
        id: variable.variableId,
        name: variable.variableId ? globalVariables.find(gVar => gVar.id === variable.variableId)?.placeHolderText : variable.name,
        content: variable.content?.map(childVariable => {
          return Object.assign({}, childVariable, {
            id: childVariable.variableId,
            name: childVariable.variableId ? globalVariables.find(gVar => gVar.id === childVariable.variableId)?.placeHolderText : childVariable.name,
          })
        })
      })
    })

    const requests = getPayloadFromFile(binaryString, file, payload.documentDTO, t, true);
    console.log({ payload, requests });

    if (requests === false || requests === undefined) {
      if (requests === false) message.error(t(`TRANSACTIONS:${TRANSACTIONS.WRONG_FILE_UPLOADED_ERROR_MESSAGE.key}`, TRANSACTIONS.WRONG_FILE_UPLOADED_ERROR_MESSAGE.value));
      return;
    };

    delete payload.documentDTO.documentId;
    delete payload.documentDTO.style;

    payload.requests = requests;
    delete payload.dataSet;
    const documentId = payload.documentDTO.id;
    delete payload.documentDTO.documentId;

    setIsSendingEmail(true);

    const response = await sendEmailsFromDraft(documentId, payload);

    if (response && response.statusCode === 200) {
      message.config({ duration: 6});
      message.success(
        t(
          TEMPLATE_VARIABLES_SIDEBAR.BATCH_UPLOAD_SUCCESS_MESSAGE.key,
          TEMPLATE_VARIABLES_SIDEBAR.BATCH_UPLOAD_SUCCESS_MESSAGE.value,
        ),
      );
      message.config({ duration: 1.5 });
    }; 

    if (response && response.errors?.length === 0) {
      // Successfully sent emails
      message.success(t(
        TEMPLATE_VARIABLES_SIDEBAR.EMAIL_REQUEST_TRIGGERED.key,
        TEMPLATE_VARIABLES_SIDEBAR.EMAIL_REQUEST_TRIGGERED.value,
      ));
    } else if (response.statusCode === 2500) {
      const { planName, emailTransactionLimit } = userDetails.planMapping;
      updateArtboard({
        [CONTEXT_KEYS.UPGRADE_MODAL_INFO]: {
          visible: true,
          message: upgradeModalMessages(t, planName, emailTransactionLimit)
        },
      });
    }

    setIsSendingEmail(false);

    };
    reader.readAsBinaryString(file);
    e.target.value = '';
  }, [documentVariables, globalVariables, documentContext, businessLogics, CurrentDesign, userDetails, fromAddressId, subject, attachments]);

  const initiateTestEmail = useCallback(async () => {
    if (ENTERPRISE_ENV || checkSessionUserAccess(userDetails, 'master')) {
      toggleShowModal(true);
      return;
    }
    try {
      const response = await fetchUserDetails();
      const { planName, emailTransactionLimit } = response.data.planMapping;
      if (response.data.isEmailTransactionFull) {
        updateArtboard({
          [CONTEXT_KEYS.UPGRADE_MODAL_INFO]: {
            visible: true,
            message: upgradeModalMessages(t, planName, emailTransactionLimit)
          },
        });
      } else {
        toggleShowModal(true);
      }
    } catch (e) {
      console.error(e);
    }
  }, []);

  const showPassword = attachments?.reduce((acc, t) => acc || t['passwordProtected'], false);

  return (
    <Container onKeyDown={e => e.stopPropagation()} isComplexDesign={1}>
      <TitleContainer>
        <RowSection>
          <Title>
            <p>
              {t(
                TEMPLATE_VARIABLES_SIDEBAR.PREVIEW_SEND_EMAIL_DESCRIPTION.key,
                TEMPLATE_VARIABLES_SIDEBAR.PREVIEW_SEND_EMAIL_DESCRIPTION.value,
              )}
            </p>
          </Title>
        </RowSection>
        {disablePreviewDownload && (
          <RowSection>
            <Title>
              <p className="error-message">
                <Icon type="exclamation-circle" />{' '}
                {t(
                  TEMPLATE_VARIABLES_SIDEBAR.ERROR_IN_DOCUMENT.key,
                  TEMPLATE_VARIABLES_SIDEBAR.ERROR_IN_DOCUMENT.value,
                )}
              </p>
            </Title>
          </RowSection>
        )}
        <RowSection isPreview={1} marginTop>
          <ComplexEmailPreview
            isVariablesTab={true}
            sampleDatas={examplValuesData}
            documentVariables={documentVariables}
            globalVariables={globalVariables}
            documentStyleContextRef={documentStyleContextRef}
            setErrorMessages={setErrorMessages}
          />
          {CurrentDesign === 'document' && (
            <DownloadButton
              id={'more-options-download'}
              onClick={() => initiateTestEmail()}
              disabled={disablePreviewDownload}
            >
              {t(
                `COMPLEX_VARIABLES_SIDEBAR:${COMPLEX_VARIABLES_SIDEBAR.SEND_EMAIL_BUTTON.key}`,
                COMPLEX_VARIABLES_SIDEBAR.SEND_EMAIL_BUTTON.value,
              )}

        {!disablePreviewDownload && !sendingEmail && CurrentDesign === TEMPLATE_TYPE.DOCUMENT && documentVariables.length > 0 && (<Dropdown
                    overlay={
                      <Menu mode="vertical">
                        <Menu.ItemGroup title={'Batch download'}>
                          <Menu.SubMenu
                            key="1"
                            title={
                              <span>                                
                                {t(
                                  `COMPLEX_VARIABLES_SIDEBAR:${COMPLEX_VARIABLES_SIDEBAR.DOWNLOAD_SAMPLE_FORMAT_BUTTON.key}`,
                                  COMPLEX_VARIABLES_SIDEBAR.DOWNLOAD_SAMPLE_FORMAT_BUTTON.value,
                                )}
                              </span>
                            }
                            popupClassName="custom-download"
                onTitleClick={(e) => { e.domEvent.stopPropagation(); }}
                          >
                  <Menu.Item
                    key="1"
                    onClick={batchExcelSample}
                  >
                              Excel
                            </Menu.Item>
                            <Menu.Item
                              key="2"
                    onClick={(e) => {
                                sendTestEmail('', '', true, e);
                              }}
                            >
                              JSON
                            </Menu.Item>
                            <Menu.Item
                              key="3"
                    onClick={(e) => {
                                sendTestEmail('', '', true, e, 'xml');
                              }}
                            >
                              XML
                            </Menu.Item>
                          </Menu.SubMenu>
                          <Menu.Item
                            key="2"
                onClick={(e) => { e.domEvent.stopPropagation(); fileRef.current.click(); }}
                          >
                            <div>
                              <input
                                type="file"
                                ref={fileRef}
                                style={{ display: 'none' }}
                                onInput={onImportFile}
                              />
                              {t(
                                `COMPLEX_VARIABLES_SIDEBAR:${COMPLEX_VARIABLES_SIDEBAR.SENT_BULK_EMAIL_BUTTON.key}`,
                                COMPLEX_VARIABLES_SIDEBAR.SENT_BULK_EMAIL_BUTTON.value,
                              )}
                            </div>
                          </Menu.Item>
                        </Menu.ItemGroup>
                      </Menu>
                    }
                    placement={'bottomRight'}
                    trigger={['hover']}
                    getPopupContainer={() => document.getElementById('more-options-download')}
                  >
                    <Icon
                      type="down"
                      style={{ padding: 10, paddingRight: 0 }}
               onClick={(e) => {
                        e.stopPropagation();                
                      }}
                    />
             </Dropdown>)}
              {sendingEmail && (
               <Spin style={{ paddingLeft: 10 }} indicator={<Icon type="loading" style={{ color: 'black' }} />}></Spin>
              )}
          </DownloadButton>)}
        </RowSection>

        {CurrentDesign === TEMPLATE_TYPE.DOCUMENT && checkSessionUserAccess(userDetails, 'master') && (
          <>
            <RowSection isPreview={1} releaseBtn marginTop>

            </RowSection>

            <RowSection isPreview={1} releaseBtn marginTop>
              <div className="swith-btn">
                {' '}
                <Switch checked={toggleButton} onChange={() => handleShowDesign(toggleButton)} />{' '}
                &nbsp; &nbsp;
                {t(
                  `COMPLEX_VARIABLES_SIDEBAR:${COMPLEX_VARIABLES_SIDEBAR.SHOW_DESIGN_BUTTON.key}`,
                  COMPLEX_VARIABLES_SIDEBAR.SHOW_DESIGN_BUTTON.value,
                )}
              </div>
              <Button onClick={() => setShowOrganizationList(true)} loading={designReleaseLoading}>
                {t(
                  `COMPLEX_VARIABLES_SIDEBAR:${COMPLEX_VARIABLES_SIDEBAR.RELEASE_DESIGN_BUTTON.key}`,
                  COMPLEX_VARIABLES_SIDEBAR.RELEASE_DESIGN_BUTTON.value,
                )}
              </Button>
            </RowSection>
          </>
        )}
      </TitleContainer>
      <ListContainer>
        <VariableForm
          documentVariables={documentVariables}
          examplValuesData={examplValuesData}
          setExamplValuesData={setExamplValuesData}
          errorMessages={errorMessages}
          setIsHtmlExpanded={setIsHtmlExpanded}
          isHtmlExpanded={isHtmlExpanded}
        />
      </ListContainer>
      {showModal && <SendTestEmail
          isLoading={sendingEmail}
          sendTestEmail={sendTestEmail}
          onCancel={() => toggleShowModal(false)}
          isDefaultSMTP={false}
          showPassword={showPassword}
      />}
      {showOrganizationList &&
        <SelectOrganization
          organizationId={organizationId}
          visible={showOrganizationList}
          onCancel={() => setShowOrganizationList(false)}
          handleClick={(data) => handleReleaseDesign(data)} />}
    </Container>
  );
}

export default ComplexEmailVariableList;